import { useMutation } from '@tanstack/react-query';

import { ExpensesApi } from '../expenses.api';

export const useGetCalculationsOnProductExpansesUpdate = () => {
  return useMutation({
    mutationFn: ExpensesApi.getExpensesByProduct,
  });
};
